<template>
    <div class="vx-col md:w-full sm:w-auto" style="width: 300px !important;">
        <div class="vx-row md:w-full">

            <vx-tooltip class="position-icon" :text="$t('button.edit')" position="top">
                <feather-icon icon="EditIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="editKeyword"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord"/>
            </vx-tooltip>
        </div>
    </div>
</template>

<script>


export default {
    name: 'CellRendererActionsKeyword',
    methods: {
        editKeyword() {
            this.$router.push(`/user/restricted-keywords-info?id=${this.params.data.id}`).catch(() => {
            })
        },
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: 'Bạn có chắc là muốn xóa từ khóa hạn chế này không?',
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.$vs.loading();
            const url = '/beauty-foul-keyword/delete/';
            this.$crm.get(url + this.params.data.id).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: 'Xoá thành công',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                this.$store.commit('UPDATE_NEW_KEYWORDS', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
    }
}
</script>

<style scoped></style>

